const GET_DISTRICT_ASSIGNMENTS =
  `query GetAssignments($entityId: ID!, $entityType: Entity!,$filter: AssignmentQueryFilter) {
    assignment(entityId: $entityId, entityType: $entityType, filter: $filter) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        activity {
          activityId
          assignmentId
          displayStatus
          status
          storyId
          tags
          type
        }
      }
    }
  }`;

  export default GET_DISTRICT_ASSIGNMENTS;